import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { includes } from 'lodash/fp';
import * as Sentry from '@sentry/browser';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getMessageLocale } from './common/utils';
import App from './app';
import initFirebase from './firebase';

const SUPPORTED_LOCALES = ['en', 'ko', 'ja', 'zh-CN', 'zh-TW'];

dayjs.extend(relativeTime);

const initIntl = async () => {
  const locale = getMessageLocale({ locale: navigator.language, preserved: ['zh'] });

  const isSupportedLocale = includes(locale, SUPPORTED_LOCALES);
  const translation = await import(`./translations/${isSupportedLocale ? locale : 'en'}.json`);

  return translation.default;
};

const initSentry = () => Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: 'school-dashboard',
  debug: process.env.NODE_ENV !== 'production',
  environment: process.env.REACT_APP_STAGE,
});

const init = async () => {
  initSentry();

  initFirebase();

  const translation = await initIntl();

  ReactDOM.render((
    <Router>
      <App translation={translation} />
    </Router>
  ), document.getElementById('root'));
};

init();
